import * as React from "react";

export const FilterModalIcon = (props: any) => (
  <svg
    width={52}
    height={52}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M26 26v6l-4 2v-8l-6-9v-2h16v2l-6 9Zm-7.596-9L24 25.394 29.596 17H18.404Z"
      fill="#333"
    />
    <rect width={48} height={48} rx={24} stroke="#ECFDF3" strokeWidth={8} />
  </svg>
);
